import React from 'react';
import { StaffDashboard as StaffDashboardComponent } from '@/components/dashboard/StaffDashboard';
import { useIndexState } from '@/hooks/useIndexState';
import { useAuth } from '@/components/auth/AuthProvider';
import { useNavigate } from 'react-router-dom';

export const StaffDashboard = () => {
  const { profile } = useAuth();
  const navigate = useNavigate();
  
  const {
    orders,
    ordersLoading,
    ordersError,
    handleViewProducts,
    handleEditOrder,
  } = useIndexState();

  const handleNewOrder = () => {
    navigate('/checkin');
  };

  const handlePriceCheck = () => {
    navigate('/?view=prices');
  };

  const handleEmployeeClockIn = () => {
    navigate('/staff/clock-in');
  };

  const handleRequestAdminAccess = () => {
    navigate('/?admin-pin=true');
  };

  const handleNavigateToMissingProducts = () => {
    navigate('/non-scanning-products');
  };

  const handleViewAllScannedItems = () => {
    navigate('/staff/scanned-items');
  };

  return (
    <StaffDashboardComponent
      userName={profile?.full_name || profile?.email || null}
      orders={orders}
      onNewOrder={handleNewOrder}
      onPriceCheck={handlePriceCheck}
      onEmployeeClockIn={handleEmployeeClockIn}
      onViewAllScannedItems={handleViewAllScannedItems}
      onEditOrder={handleEditOrder}
      onViewProducts={handleViewProducts}
      onRequestAdminAccess={handleRequestAdminAccess}
      onNavigateToMissingProducts={handleNavigateToMissingProducts}
      isLoading={ordersLoading}
      error={ordersError}
    />
  );
};